export default __webpack_public_path__ + "static/media/fr5.b198abf6.webp";